module.exports = __webpack_public_path__ + "static/media/axie-logo.3e169906.jpg";